import {API_KEY} from "./my_key.js";
import {chapter,chapter01} from "./chapter.js";

export function book_01(){
  var activities_book = document.getElementById("book_type");
  activities_book.addEventListener("change", function() {
    var x = activities_book.selectedIndex;
    var y = document.getElementById("bible_type").selectedIndex;
    console.log("apa la");
    console.log(activities_book.options[activities_book.selectedIndex].value);
    console.log(activities_book.options[activities_book.selectedIndex].id);
    chapter(activities_book.options[activities_book.selectedIndex].id,activities_book.options[activities_book.selectedIndex].value,document.getElementById("bible_type").options[document.getElementById("bible_type").selectedIndex].value);

});
chapter01();
}
  const bibleBookList = document.querySelector(`#book-list`);
  const breadcrumbs = document.querySelector(`#breadcrumbs`);



  export async function book_output(bibleVersionIDs,abbreviations){
    var jsonArray = [];
    var bibleVersionID = bibleVersionIDs;
    var abbreviation = abbreviations;

    let bookHTML = ``;

 

 document.getElementById("book_type").innerText = null;
   await getBooks(bibleVersionIDs).then((bookList) => {
      bookHTML += `<ul>`;
      for (let book of bookList) {
         var option = document.createElement("option");
            option.id = book.id;
            option.value = bibleVersionIDs;
            option.text = book.name;
       var jsonObject = {
  "id": book.id,
  "value":bibleVersionIDs,
  "text": book.name
};

jsonArray.push(jsonObject);
     }
 
    });

    return jsonArray;

}
    /**
     * Gets books of the Bible from API.Bible
     * @param {string} bibleVersionID to get books from
     * @returns {Promise} containing list of books of the Bible
     */
  async function getBooks(bibleVersionID) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.withCredentials = false;

        xhr.addEventListener(`readystatechange`, function() {
          if (this.readyState === this.DONE) {
            const {data} = JSON.parse(this.responseText);
            const books = data.map( ({name, id}) => { return {name, id}; } );

            resolve(books);
          }
        });

        xhr.open(`GET`, `https://api.scripture.api.bible/v1/bibles/${bibleVersionID}/books`);
        xhr.setRequestHeader(`api-key`, API_KEY);

        xhr.onerror = () => reject(xhr.statusText);

        xhr.send();
      });
    }

    /**
     * Gets query parameter from URL based on name
     * @param {string} name of query parameter
     * @returns {string} value of query parameter
     */
    function getParameterByName(name) {
      const url = window.location.href;
      name = name.replace(/[\[\]]/g, `\\$&`);
      const regex = new RegExp(`[?&]` + name + `(=([^&#]*)|&|#|$)`),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return ``;
      return decodeURIComponent(results[2].replace(/\+/g, ` `));
    }

    /**
     * Loads page for new search
     */
   /* 
  This function is not yet being utalized much ... 2/3/2023
   function searchButton(){
      const searchInput = document.querySelector(`#search-input`);
      window.location.href = `./search.html?&version=${bibleVersionID}&abbr=${abbreviation}&query=${searchInput.value}`;
    }*/